import { ca } from '@cian/analytics';

import { EDeviceType } from '../../types/device';
import { IFavoriteEntity } from '../../types/results';
import { EOfferType, getPageNumber } from '../../utils/trackings';

interface IToCardEventParameters {
  entity: IFavoriteEntity;
  position: number;
  total: number;
  deviceType: EDeviceType;
  label: 'card_header' | 'card_photo' | 'card_button';
}

export const trackCardClick = ({ entity, position, total, deviceType, label }: IToCardEventParameters) => {
  ca('eventEbc', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'to_card',
    label,
    page: {
      listingType: 'list',
      sortType: 'default',
      pageNumber: getPageNumber(total, position),
      offersQty: total,
      pageType: 'ListingFavorites',
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
    },
    products: [favoriteEntityToTrackingProduct(entity, position)],
  });
};

function favoriteEntityToTrackingProduct(entity: IFavoriteEntity, position: number) {
  /**
   * Объект products для карточки ЖК
   */
  if (entity.jkInfo) {
    return {
      id: entity.entityId,
      offerType: EOfferType.JK,
      position,
    };
  }

  /**
   * Объект products для карточки объявления
   */
  return {
    id: entity.entityId,
    offerType: EOfferType.Offer,
    position,
    published: entity ? entity.status === 'published' : false,
  };
}
